import { render, staticRenderFns } from "./AnimalTown.vue?vue&type=template&id=0f15d866&scoped=true"
import script from "./AnimalTown.vue?vue&type=script&lang=js"
export * from "./AnimalTown.vue?vue&type=script&lang=js"
import style0 from "./AnimalTown.vue?vue&type=style&index=0&id=0f15d866&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15d866",
  null
  
)

export default component.exports